const PostTermClasses = {
  generatePostClassesWithTerms: (terms) => {
    let classes = '';
    for (const key in terms) {
      if (key in terms) {
        if (terms[key].length) {
          classes = classes.concat(' ') + terms[key].join(' ');
        }
      }
    }
    return classes;
  },
};

export default PostTermClasses;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/layout/grid/gridhelper/generatePostClassesWithTerms.js